import React from 'react';
import { Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-navy py-16" style={{ color: '#FBF7EE' }}>
      <div className="max-w-[1300px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3">
              <img
                src="/images/logo/KE-white.png"
                alt="Karma Experience"
                className="h-10 w-auto object-contain"
              />
            </div>
            <p className="mt-5 font-serif-editorial text-lg leading-relaxed max-w-md" style={{ color: 'rgba(251,247,238,0.8)' }}>
              A collection of extraordinary escapes, carefully curated across Europe and Asia.
            </p>
          </div>

          <div>
            <div className="chapter-badge text-gold uppercase mb-4">Get In Touch</div>
            <ul className="space-y-3 text-[0.95rem]" style={{ color: 'rgba(251,247,238,0.85)' }}>
              <li className="flex items-center gap-3">
                <Mail size={15} className="text-gold shrink-0" />
                <a
                  href="mailto:invitations@karmaexperience.co.uk"
                  className="link-underline"
                  data-testid="footer-email-link"
                >
                  invitations@karmaexperience.co.uk
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="chapter-badge text-gold uppercase mb-4">Journey</div>
            <ul className="space-y-3 text-[0.95rem]" style={{ color: 'rgba(251,247,238,0.85)' }}>
              <li><a href="#how" className="link-underline">How It Works</a></li>
              <li><a href="#discover" className="link-underline">Destinations</a></li>
              <li><a href="#faq" className="link-underline">FAQ</a></li>
              <li><a href="/activate" className="link-underline">Activate Voucher</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 flex flex-col md:flex-row items-center justify-between gap-3" style={{ borderTop: '1px solid rgba(251,247,238,0.12)' }}>
          <div className="chapter-badge uppercase" style={{ color: 'rgba(251,247,238,0.6)' }}>
            © {new Date().getFullYear()} Karma Experience · A Collection of Extraordinary Escapes
          </div>
          <div className="chapter-badge uppercase flex items-center gap-3" style={{ color: 'rgba(251,247,238,0.75)' }}>
            <a
              href="https://karmaexperience.co.uk/privacy-policy.php"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gold transition-colors underline"
            >
              Privacy Policy
            </a>
            <span>·</span>
            <a
              href="https://karmaexperience.co.uk/terms-and-conditions.php"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gold transition-colors underline"
            >
              Terms and Conditions
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
